'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = quotedOrList;
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var MAX_LENGTH = 5;

/**
 * Given [ A, B, C ] return '"A", "B", or "C"'.
 */
function quotedOrList(items) {
  var selected = items.slice(0, MAX_LENGTH);
  return selected.map(function (item) {
    return '"' + item + '"';
  }).reduce(function (list, quoted, index) {
    return list + (selected.length > 2 ? ', ' : ' ') + (index === selected.length - 1 ? 'or ' : '') + quoted;
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/graphql/jsutils/quotedOrList.js
// module id = 106
// module chunks = 34471704633725 35783957827783 216468464745311